import { Button, Paper, Typography } from "@mui/material";
import { GridFooter } from "@mui/x-data-grid-pro";
import { useConfirm } from "material-ui-confirm";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import i18next from "i18next";

export const FixturesFooter = ({
  selectionModel,
  mode,
  handleCompileConfirm,
  handleEvaluateConfirm,
}) => {
  const confirm = useConfirm();

  const handleConfirm = async () => {
    if (mode === "compile") {
      await handleCompileConfirm();
      return;
    }

    await confirm(
      {
            title: `Evaluate ${selectionModel.length} matches?`,
            description:
              "The evaluation of the matches induces an update of all parameters involved in the calculation for upcoming fixtures. Make sure you are happy with your settings.",
      }
    );
    await handleEvaluateConfirm();
  };

  return (
    <div
      style={{
        position: "relative",
        height: "200%",
      }}
    >
      <Paper
        sx={{ px: 1 }}
        style={{
          position: "absolute",
          display: "flex",
          alignItems: "center",
          height: "50%",
          bottom: 0,
          width: "100%",
          background: "white",
        }}
      >
        <Typography variant="body2" sx={{ mr: 1.5 }}>
          {i18next.t("help.compilePreview.selectedFixtures", { count: selectionModel.length })}
        </Typography>
        <Button
          variant="contained"
          startIcon={<PlayArrowIcon />}
          disabled={!selectionModel.length}
          onClick={handleConfirm}
        >
          {i18next.t(mode === "compile"
            ? "help.compilePreview.startCompile"
            : "help.compilePreview.startEvaluate")}
        </Button>
      </Paper>
      <GridFooter />
    </div>
  );
};
